import React from "react";
import {
    createBrowserRouter,
} from "react-router-dom";

import routes from "./routes";
import Layout from "./views/Layout";

export const routerIndex = createBrowserRouter([
    {
        path: "/",
        element: <Layout />,
        children: routes
    }
], {
    basename: "/pages",
})
